import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// IMPORTAR OS COMPONENTES
import ProjetosErnedu from './ProjetosErnedu';
import ProjetosAdvantec from './ProjetosAdvantec';
import ProjetosPlaceholder from './ProjetosPlaceholder';

const Projetos_cliente = () => {
  const { cliente_id } = useParams();
  const navigate = useNavigate();

  // SE FOR CLIENTE 2 (ERNEDU) → Componente Funcional
  if (cliente_id === '2') {
    return <ProjetosErnedu />;
  }

  // CLIENTES COM ANÁLISE DE DEPARTAMENTOS (25 Advantec, 27 Advwg)
  if (['25', '27'].includes(cliente_id)) {
    return <ProjetosAdvantec />;
  }

  // QUALQUER OUTRO CLIENTE → Placeholder
  return <ProjetosPlaceholder cliente_id={cliente_id} />;
};

export default Projetos_cliente;